import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  LoaderSize,
  LoaderThemeColor,
  LoaderType,
} from '@progress/kendo-angular-indicators';
import { Observable, Subscription } from 'rxjs';
import { LoginService } from 'src/app/core/services/login/login.service';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import { selectFirstAndLastName } from 'src/app/core/store/onboarding/reducers+selectors/create-account.selector';
import { destructSubscriptionArray } from 'src/app/core/ui-helpers/functions/destruct-subscription-array';
import { reloadApp } from 'src/app/core/ui-helpers/functions/redirect/reload-app';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-account-bubble',
  templateUrl: './account-bubble.component.html',
  styleUrls: ['./account-bubble.component.scss'],
})
export class AccountBubbleComponent implements OnInit, OnDestroy {
  nameProperties$: Observable<any>;
  subscriptions: Subscription[] = [];
  initials: string;
  isAccountBubbleOpen = false;

  selected = false;
  loader = {
    type: <LoaderType>'converging-spinner',
    themeColor: <LoaderThemeColor>'secondary',
    size: <LoaderSize>'small',
  };

  constructor(
    private elementRef: ElementRef,
    private ls: LoginService,
    private store: Store<IAppState>,
    private route: Router,
  ) {}

  ngOnInit(): void {
    this.loader.themeColor = <LoaderThemeColor>'primary';
    this.nameProperties$ = this.store.select(selectFirstAndLastName);
    this.subscriptions.push(
      this.nameProperties$.subscribe((props) => {
        if (props.firstName === '' || props.lastName === '') {
          this.initials = 'FL';
        }
        this.initials = props.firstName.charAt(0) + props.lastName.charAt(0);
      }),
    );
  }

  ngOnDestroy(): void {
    destructSubscriptionArray(this.subscriptions);
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.elementRef) return;
    // Check if the click target is outside the component
    const isClickedOutside = !this.elementRef.nativeElement.contains(
      event.target,
    );
    if (isClickedOutside) this.closeAccountBubble();
  }

  openAccountBubble() {
    this.isAccountBubbleOpen = !this.isAccountBubbleOpen;
  }

  closeAccountBubble() {
    if (this.isAccountBubbleOpen)
      this.isAccountBubbleOpen = !this.isAccountBubbleOpen;
  }

  async logout() {
    this.selected = true;
    await this.subscriptions.push(
      this.ls.logout().subscribe((res: any) => {
        if (res === true) {
          reloadApp(environment);
        } else {
          this.selected = false;
        }
      }),
    );
    return true;
  }
}
